<i *ngIf="icon && ICONS[icon]" [innerHtml]="ICONS[icon]"></i>